var React = require('react');

function Validated (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 10.233L8.875 15L17 5","stroke":"currentColor","strokeWidth":"3"}));
}

Validated.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 20 20","fill":"none"};

module.exports = Validated;

Validated.default = Validated;
